<section id="fertig" fxLayout="column" fxLayoutAlign="start center" ngClass.lt-md="lt-md" ngClass.lt-sm="lt-sm">
  <div fxLayout="column" fxLayoutAlign="center center" class="search-container">
    <mat-form-field appearance="outline" color="accent" class="search-input-form-field">
      <mat-label>Suchen</mat-label>
      <input class="search-input" matInput type="text" [(ngModel)]="searchString" (keyup)="startSearchTimer($event)"
             (focus)="searchGotFocus($event, false)" (blur)="searchGotFocus($event, true)"
             name="search" tabindex="1">
      <button mat-button *ngIf="searchString" matSuffix mat-icon-button
              (click)="searchString=''; searchResult = undefined">
        <mat-icon>close</mat-icon>
      </button>
      <mat-icon matPrefix class="search-icon">search</mat-icon>
    </mat-form-field>
    <mat-spinner *ngIf="searching" color="accent"></mat-spinner>
    <div class="search-result" *ngIf="searchResult">
      <h2>Suchergebnisse</h2>
      <div style="margin-bottom: 20px" *ngIf="searchResult.objekte && searchResult.objekte.length > 0">
        <h3>Folgende Shops passen zu Deiner Suche:</h3>
        <div *ngFor="let suchObjekt of searchResult.objekte">
          <app-gallery-scroller style="display: block; margin-bottom: 10px" [ladenObjects]="suchObjekt.objekte"
                                [smallImages]="true" [showLabelsOnlyOnFirstItem]="true"
                                [showIndividualLabels]="true" individualLabelKey="branche"></app-gallery-scroller>
        </div>
      </div>
      <div *ngIf="searchResult.branchen && searchResult.branchen.length > 0">
        <h3>Folgende Branchen passen zu Deiner Suche:</h3>
        <ul class="branchenlist" *ngFor="let suchBranche of searchResult.branchen">
          <li (click)="openOverlay(suchBranche.id)">{{suchBranche.name}}</li>
        </ul>
      </div>
      <div *ngIf="searchResult.referenzen && searchResult.referenzen.length > 0">
        <h3>Die folgenden Treffer kommen aus unserer Referenzliste:</h3>
        <div *ngFor="let suchReferenz of searchResult.referenzen">
          <h4>{{suchReferenz.branche}}</h4>
          <div *ngFor="let objekt of suchReferenz.objekte">
            <span>{{objekt.name}}</span>
            <span>{{objekt.text1}}</span>
            <span>{{objekt.text2}}</span>
          </div>
        </div>
      </div>
      <div
        *ngIf="(!searchResult.objekte || searchResult.objekte.length == 0) && (!searchResult.branchen || searchResult.branchen.length == 0) && (!searchResult.referenzen || searchResult.referenzen.length == 0)">
        Nichts gefunden - versuch einen neuen Suchbegriff.
      </div>
    </div>
  </div>
</section>
